import * as swcHelpers from '@swc/helpers';

function getForwardedQueryParamsFromFacets(facets, currentRefinements) {
    const params = facets.reduce((result, facet)=>{
        if (!currentRefinements || Object.keys(currentRefinements).length === 0) {
            return result;
        }
        if (facet.forwardAsQueryParam && facet.attribute in currentRefinements && Boolean(currentRefinements[facet.attribute])) {
            return swcHelpers.objectSpread({}, result, {
                [facet.id]: currentRefinements[facet.attribute].join(',')
            });
        }
        return result;
    }, {});
    if (Object.keys(params).length === 0) {
        return undefined;
    }
    return params;
}

export { getForwardedQueryParamsFromFacets };
//# sourceMappingURL=get-forwarded-query-params-from-facets.js.map
